import { render, staticRenderFns } from "./OrderAddressView.vue?vue&type=template&id=3f6c1a2d&"
import script from "./OrderAddressView.vue?vue&type=script&lang=js&"
export * from "./OrderAddressView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports